module.exports = __webpack_public_path__ + "img/ypdc1.acd57ba1.jpg";